module.exports = __webpack_public_path__ + "static/media/lt_wco.f4242ea4.png";